(function(){
  var root=document.documentElement;
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Point collection links straight at "price, high to low" so the page never has to redirect */
  function sortLinks(scope){
    (scope||document).querySelectorAll('a[href*="/collections/"]').forEach(function(a){
      try{
        var u=new URL(a.getAttribute('href'),location.href);
        if(u.origin!==location.origin||!/^\/collections\/[^\/]+\/?$/.test(u.pathname)||u.searchParams.has('sort_by'))return;
        u.searchParams.set('sort_by','price-descending');
        a.setAttribute('href',u.pathname+u.search+u.hash);
      }catch(e){}
    });
  }

  /* Pause looping animations in sections that are off screen */
  var pauseIO=('IntersectionObserver' in window)?new IntersectionObserver(function(entries){
    entries.forEach(function(e){e.target.classList.toggle('av-offscreen',!e.isIntersecting);});
  },{rootMargin:'150px 0px'}):null;
  function watchPause(){
    if(!pauseIO)return;
    document.querySelectorAll('main .shopify-section, footer .shopify-section').forEach(function(s){
      if(!s.__avPause){s.__avPause=1;pauseIO.observe(s);}
    });
  }

  /* Scroll reveal */
  var io=(!reduce&&'IntersectionObserver' in window)?new IntersectionObserver(function(entries){
    entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});
  },{threshold:0,rootMargin:'0px 0px -40px 0px'}):null; /* 0: a section taller than the screen could never reach a percentage, and stayed hidden */
  function autoTag(){
    document.querySelectorAll('main .shopify-section').forEach(function(s,i){
      if(i===0||s.querySelector('[data-av-reveal]')||s.hasAttribute('data-av-reveal'))return;
      s.setAttribute('data-av-reveal','');
    });
    document.querySelectorAll('main product-card, main .product-card').forEach(function(c,i){
      if(c.closest('[data-av-reveal]:not(.is-in)')||c.hasAttribute('data-av-reveal'))return;
      c.setAttribute('data-av-reveal','');c.style.setProperty('--av-delay',((i%4)*0.08)+'s');
    });
  }
  function watchReveal(){
    document.querySelectorAll('[data-av-reveal]:not(.is-in)').forEach(function(el){
      if(io)io.observe(el);else el.classList.add('is-in');
    });
  }

  /* Flagship products (tagged "flagship") go ahead of any product with the same price */
  function flagshipFirst(){
    var F=window.AV_FLAGSHIP||[];
    F.forEach(function(handle){
      document.querySelectorAll('main a[href*="/products/'+handle+'"]').forEach(function(a){
        var card=a.closest('product-card, .product-card'); if(!card)return;
        var item=card.closest('li')||card, grid=item.parentElement; if(!grid)return;
        var priceEl=card.querySelector('.price'); if(!priceEl)return;
        var price=priceEl.textContent.replace(/\s+/g,' ').trim();
        var sibs=[].slice.call(grid.children), idx=sibs.indexOf(item);
        for(var i=0;i<idx;i++){
          var sp=sibs[i].querySelector('.price');
          if(sp&&sp.textContent.replace(/\s+/g,' ').trim()===price&&!(sibs[i].querySelector('a[href*="/products/'+handle+'"]'))){
            var isFlag=F.some(function(h){return sibs[i].querySelector('a[href*="/products/'+h+'"]');});
            if(!isFlag){grid.insertBefore(item,sibs[i]);}
            break;
          }
        }
      });
    });
  }

  /* Cards on the app page: make the whole tile clickable when it holds a single link */
  function cardLinks(){
    document.querySelectorAll('.nt-card, .sr-card').forEach(function(card){
      if(card.__avLink)return;
      var links=card.querySelectorAll('a[href]');
      if(links.length!==1)return;
      var a=links[0];
      card.__avLink=1;
      card.style.cursor='pointer';
      card.addEventListener('click',function(e){
        if(e.target.closest('a'))return;
        if(window.getSelection&&String(window.getSelection()))return;
        if(a.target==='_blank'){window.open(a.href,'_blank','noopener');}
        else{window.location.href=a.href;}
      });
    });
  }

  /* Theme settings > Product order: those products lead the Products page and search grids */
  function cardHandle(card){
    var P=window.AV_APP_PAGES||{}, a=card.querySelector('a[href]'); if(!a)return null;
    try{
      var path=new URL(a.getAttribute('href'),location.href).pathname.replace(/\/$/,'');
      var m=path.match(/\/products\/([^\/]+)$/); if(m)return decodeURIComponent(m[1]);
      for(var h in P){ if(P[h].replace(/\/$/,'')===path) return h; }
    }catch(e){}
    return null;
  }
  function orderFirst(){
    var O=window.AV_ORDER||[]; if(!O.length)return;
    document.querySelectorAll('main product-card, main .product-card').forEach(function(c){ c.__avGrid=1; });
    var grids=new Set();
    document.querySelectorAll('main product-card, main .product-card').forEach(function(card){
      var item=card.closest('li')||card; if(item.parentElement)grids.add(item.parentElement);
    });
    grids.forEach(function(grid){
      var items=[].slice.call(grid.children), byHandle={};
      items.forEach(function(it){ var c=it.matches('product-card, .product-card')?it:it.querySelector('product-card, .product-card'); var h=c&&cardHandle(c); if(h&&!byHandle[h])byHandle[h]=it; });
      var pos=0;
      O.forEach(function(h){
        var it=byHandle[h]; if(!it)return;
        if(grid.children[pos]!==it) grid.insertBefore(it, grid.children[pos]);
        pos++;
      });
    });
  }

  /* App products: links to the product go straight to the app's own page (product field "App page link") */
  function appPageFor(href){
    var P=window.AV_APP_PAGES||{};
    try{
      var u=new URL(href,location.href);
      if(u.origin!==location.origin)return null;
      var m=u.pathname.match(/\/products\/([^\/?#]+)\/?$/);
      return m&&P[decodeURIComponent(m[1])]||null;
    }catch(e){return null;}
  }
  function appLinks(){
    document.querySelectorAll('a[href*="/products/"]').forEach(function(a){
      var page=appPageFor(a.getAttribute('href'));
      if(page)a.setAttribute('href',page);
    });
  }
  document.addEventListener('click',function(e){
    if(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
    var a=e.target.closest&&e.target.closest('a[href]');
    var page=a&&appPageFor(a.getAttribute('href'));
    if(!page)return;
    e.preventDefault();e.stopImmediatePropagation();
    window.location.href=page;
  },true);

  /* Contact page: /pages/contact?app=stadium-remote (or nashville-trainer) pre-fills the message for app support */
  var AV_APP_SUPPORT={
    'stadium-remote':{name:'Stadium Remote',body:'App: Stadium Remote\nDevice (iPhone, iPad or iPhone Duo): \niOS version: \nApp version: \nHelix Stadium firmware: \nConnected over (Wi-Fi or USB-C): \n\nWhat’s going on:\n'},
    'nashville-trainer':{name:'Nashville Trainer',body:'App: Nashville Trainer\niPhone model: \niOS version: \nApp version: \nFree or Pro: \n\nWhat’s going on:\n'}
  };
  function isTemplate(text){
    var t=(text||'').trim(); if(!t)return true;
    return Object.keys(AV_APP_SUPPORT).some(function(k){return AV_APP_SUPPORT[k].body.trim()===t;});
  }
  function contactPrefill(){
    var ta=document.querySelector('textarea[name="contact[body]"]'); if(!ta)return;
    var form=ta.form;
    /* Support pages: show the help tiles under the form */
    var more=document.querySelector('.av-support .av-support__more');
    if(more&&form){ form.insertAdjacentElement('afterend', more); }
    /* Contact page dropdown: picking an app fills in its support questions */
    var sel=form&&form.querySelector('select[name="contact[Product]"]');
    if(sel&&!sel.__av){
      sel.__av=1;
      sel.addEventListener('change',function(){
        var o=sel.options[sel.selectedIndex], app=AV_APP_SUPPORT[o&&o.getAttribute('data-av-app')];
        if(isTemplate(ta.value)){ ta.value=app?app.body:''; }
        ta.style.minHeight=app?'14em':'';
      });
    }
    var fromLink=new URLSearchParams(location.search).get('app'), marker=document.querySelector('.av-support[data-av-app]');
    var key=fromLink||(marker&&marker.getAttribute('data-av-app')), info=AV_APP_SUPPORT[key]; if(!info)return;
    if(ta.__avFilled)return;
    ta.__avFilled=1;
    var opt=sel&&sel.querySelector('option[data-av-app="'+key+'"]');
    if(opt){ sel.value=opt.value; sel.dispatchEvent(new Event('change')); }
    else{
      if(!ta.value.trim())ta.value=info.body;
      if(form&&!form.querySelector('input[name="contact[App]"]')){var h=document.createElement('input');h.type='hidden';h.name='contact[App]';h.value=info.name;form.appendChild(h);}
      ta.style.minHeight='14em';
    }
    if(form&&fromLink){
      var first=form.querySelector('input[name="contact[name]"]')||form;
      var hdr=document.querySelector('#header-component');
      first.style.scrollMarginTop=((hdr?hdr.offsetHeight:80)+40)+'px';
      setTimeout(function(){first.scrollIntoView({block:'start',behavior:'smooth'});},300);
    }
  }

  /* Card add-to-cart now lives in av-cart.js (module) so the cart drawer refreshes */

  function init(){
    sortLinks();
    cardLinks();
    flagshipFirst();
    orderFirst();
    appLinks();
    contactPrefill();
    if(!reduce){autoTag();}
    watchReveal();watchPause();
    root.classList.add('av-ready');
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
  /* Catch links added later (menus, drawers, recommendations) */
  if('MutationObserver' in window){
    var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(function(){sortLinks();cardLinks();flagshipFirst();orderFirst();appLinks();watchReveal();watchPause();},200);}).observe(document.documentElement,{childList:true,subtree:true});
  }
})();